import { PortfolioTemplateReport } from "components/base/Portfolios/types";

export const FUND_TYPES = [
  "US Stock Market",
  "US Large Cap Equity",
  "US Mid Cap Equity",
  "US Small Cap Equity",
  "International Developed Equity",
  "Emerging Markets Equity",
  "US Bonds",
  "US Government Bonds",
  "US Corporate Bonds", // not currently used as of July 31, 2023, but here in case future
  "International Bonds",
  "Real Estate",
  "Sector Equity",
  "Money Market",
  "Cash Account", // not currently used as of July 31, 2023, but here in case future
] as const;

type FundTypes = (typeof FUND_TYPES)[number];

interface Fund {
  annualized_return: PortfolioTemplateReport;
  asset_class: {
    annualized_return: PortfolioTemplateReport;
    id: number;
    inflation_adjusted_annualized_return: PortfolioTemplateReport;
    name: string;
    returns_end_date: string;
    returns_start_date: string;
  };
  composition_type: string;
  date_of_inception: string;
  description: string;
  dividend_accrual_behavior: string;
  expense_ratio: PortfolioTemplateReport;
  external_link: string;
  five_year_return: PortfolioTemplateReport;
  fund_type: FundTypes;
  id: number;
  link_site_name: string;
  name: string;
  one_year_return: PortfolioTemplateReport;
  price: {
    abs_display_cents: string;
    abs_display_dollars: string;
    cents: number;
    dollars: number;
    display_cents: string;
    display_dollars: string;
    display_smart: string;
  };
  symbol: string;
  ten_year_return: PortfolioTemplateReport;
  updated_at: string;
  ytd_return: PortfolioTemplateReport;
}

type Funds = Record<FundTypes, Fund[]>;

type UseFunds = {
  error: boolean;
  funds?: Funds;
  loading: boolean;
};

export type { Fund, FundTypes, Funds, UseFunds };
